<template lang="pug">
.quotation-tab-table
  Tabs(
    :tabs="tabs"
    :index="activeIndex"
    @change="onTabChange"
  )

  div(style="margin-bottom: 16px")

  QuotationOverview(
    v-if="activeIndex === 0"
    :data="data.price_overview"
  )

  template(v-else)
    .quotation-tab-table__table
      el-table(:data="tableData[tableIndex].vendor_price")
        el-table-column(
          :prop="isZh ? 'service_name_ch' : 'service_name'"
          :label="$t('服务类别')"
          width="140"
          show-overflow-tooltip
        )
        el-table-column(
          :prop="isZh ? 'service_item_name_ch' : 'service_item_name'"
          :label="$t('服务项目')"
          width="120"
          show-overflow-tooltip
        )
        el-table-column(
          prop="unit_price"
          :label="$t('单价')"
          width="100"
        )
          template(slot-scope="scope")
            span {{ scope.row.unit_price | formatMoney }}
        el-table-column(
          prop="number"
          :label="$t('数量')"
        )
          template(slot-scope="scope")
            span {{ scope.row.number | numberWithCommas }}

        el-table-column(
          prop="total_price"
          :label="$t('总价')"
          width="150"
        )
          template(slot-scope="scope")
            span {{ scope.row.total_price | formatMoney }}
        el-table-column(
          prop="file_name"
          :label="$t('明细')"
        )
          template(slot-scope="scope")
            uploaded-file-display(
              v-if="scope.row.download_url"
              :fileName="scope.row.file_name"
              :downloadUrl="scope.row.download_url"
              :fileNameList="scope.row.file_name_list"
              width="85px"
            )
            span(v-else) —
        el-table-column(
          :label="$t('备注')"
          show-overflow-tooltip
        )
          template(slot-scope="scope")
            span {{ scope.row.remark || '—' }}

        template(v-if="isIT")
          el-table-column(
            :label="$t('可借助的其他现有UL解决方案')"
            min-width="280"
          )
            template(slot-scope="scope")
              span {{ scope.row.solutions_name || '—' }}
          el-table-column(
            :label="$t('借助其他解决方案后的报价')"
            min-width="240"
          )
            template(slot-scope="scope")
              span {{ scope.row.price_after_leveraging | formatMoney(2) }}
          el-table-column(
            :label="$t('持续时间')"
            min-width="200"
          )
            template(slot-scope="scope")
              span(v-if="!(scope.row.coverage_start_date && scope.row.coverage_end_date)") —
              span(v-else) {{ scope.row.coverage_start_date | formatDate }} ~ {{ scope.row.coverage_end_date | formatDate }}
    .quotation-tab-table__footer
      div(style="color: #f66c62")
          span {{ $t('折扣') }}:
          span -{{ tableData[tableIndex].discount | formatMoney }}
      div
        span {{ $t('小计') }}:
        span {{ tableData[tableIndex].total_price | formatMoney }}
</template>

<script>
import { formatMoney, numberWithCommas, formatDate } from '@/umcc/util'
import QuotationOverview from '@/components/QuotationOverview'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import Tabs from '@/components/Tabs'
import db from '@/umcc/db'

export default {
  components: {
    QuotationOverview,
    UploadedFileDisplay,
    Tabs
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  computed: {
    isZh () {
      return db.lang === 'zh'
    },
    tableData () {
      return this.data.vendor_price
    },
    tabs () {
      return ['Summary', ...this.tableData.map(i => i.category_name)]
    },
    tableIndex () {
      return this.activeIndex - 1
    },
    isIT () {
      const d = this.tableData[this.tableIndex].vendor_price[0]
      return d && d.category_name === 'IT'
    }
  },
  filters: {
    numberWithCommas,
    formatMoney,
    formatDate
  },
  methods: {
    onTabChange (i) {
      this.activeIndex = i
    }
  }
}
</script>

<style lang="stylus">
.quotation-tab-table
  margin-bottom 16px
  .campaign-tab
    margin-top 16px
    .el-tabs__nav
      margin-left 24px
  .quotation-overview
    margin 0 117px
  .quotation-tab-table__table
    margin 0 117px

.quotation-tab-table__tab
  display: flex
  align-items: center
  font-size: 14px

.quotation-tab-table__tab__item
  width: 180px
  text-align: center
  padding: 6px
  border-radius: 5px 5px 0px 0px
  margin-right 10px
  box-shadow: 1px -1px 5.5px 1.5px #d4d8df
  cursor: pointer

.quotation-tab-table__tab__item__active
  color: white
  background: #00a0e5

.quotation-tab-table__footer
  margin 0  117px
  border-bottom 1px solid $main
.quotation-tab-table__footer > div
  text-align right
  line-height 24px
  > span
    padding 6px
    display inline-block
    &:last-child
      text-align left
</style>
